import * as React from 'react';
import { Box, Typography } from '@mui/material';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import { useTranslation } from 'react-i18next';

/** Notatka klienta do zamowienia (np. "burger bez cebuli") - wyrozniona, zeby kuchnia jej nie przeoczyla. */
export const OrderNote: React.FC<{ note?: string | null }> = ({ note }) => {
  const { t } = useTranslation();

  if (!note?.trim()) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 'var(--space-2)',
        alignItems: 'flex-start',
        p: 'var(--space-3)',
        borderRadius: 'var(--radius-md)',
        backgroundColor: 'var(--color-warning-soft)',
        border: '1px solid var(--color-warning)',
      }}
    >
      <StickyNote2OutlinedIcon sx={{ color: 'var(--color-warning)', fontSize: 20, mt: '2px' }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 'var(--text-xs)',
            fontWeight: 700,
            letterSpacing: 'var(--tracking-wide)',
            textTransform: 'uppercase',
            color: 'var(--color-text-muted)',
          }}
        >
          {t('orders.customerNote')}
        </Typography>
        <Typography
          sx={{
            fontSize: 'var(--text-sm)',
            fontWeight: 600,
            color: 'var(--color-text-primary)',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
          }}
        >
          {note}
        </Typography>
      </Box>
    </Box>
  );
};
